module.exports = __webpack_public_path__ + "img/logo-black.b1b3a29.png";